import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const Instagram = ({ size = 24, ref, ...props }: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0009 0C8.74184 0 8.33284 0.0142502 7.05282 0.0725002C5.77531 0.131 4.9033 0.33325 4.14029 0.63C3.35104 0.9365 2.68153 1.3465 2.01452 2.01375C1.34701 2.68075 0.93701 3.35025 0.629506 4.13925C0.332003 4.9025 0.129501 5.77475 0.0720008 7.05175C0.0150002 8.33175 0 8.741 0 12C0 15.259 0.0145004 15.6668 0.072501 16.9468C0.131252 18.2243 0.333504 19.0963 0.630007 19.8593C0.93676 20.6485 1.34676 21.318 2.01402 21.985C2.68078 22.6525 3.35029 23.0635 4.13904 23.37C4.90255 23.6668 5.77481 23.869 7.05207 23.9275C8.33209 23.9858 8.74084 24 11.9996 24C15.2589 24 15.6667 23.9858 16.9467 23.9275C18.2242 23.869 19.0972 23.6668 19.8607 23.37C20.6497 23.0635 21.3182 22.6525 21.985 21.985C22.6525 21.318 23.0625 20.6485 23.37 19.8595C23.665 19.0963 23.8675 18.224 23.9275 16.947C23.985 15.667 24 15.259 24 12C24 8.741 23.985 8.332 23.9275 7.052C23.8675 5.7745 23.665 4.9025 23.37 4.1395C23.0625 3.35025 22.6525 2.68075 21.985 2.01375C21.3175 1.34625 20.65 0.93625 19.86 0.63C19.095 0.33325 18.2224 0.131 16.9449 0.0725002C15.6649 0.0142502 15.2574 0 11.9974 0H12.0009ZM10.9244 2.1625C11.2439 2.162 11.6004 2.1625 12.0009 2.1625C15.2049 2.1625 15.5847 2.174 16.8499 2.2315C18.0199 2.285 18.6549 2.4805 19.0779 2.64475C19.638 2.86225 20.0372 3.12225 20.457 3.54225C20.877 3.96225 21.137 4.36225 21.355 4.92225C21.5192 5.34475 21.715 5.97975 21.7682 7.14975C21.8257 8.41475 21.8382 8.79475 21.8382 11.9972C21.8382 15.1997 21.8257 15.5798 21.7682 16.8448C21.7147 18.0147 21.5192 18.6498 21.355 19.0723C21.1375 19.6323 20.877 20.031 20.457 20.4508C20.037 20.8708 19.6382 21.1308 19.0779 21.3482C18.6554 21.5133 18.0199 21.7082 16.8499 21.7617C15.5849 21.8192 15.2049 21.8318 12.0009 21.8318C8.79659 21.8318 8.41684 21.8192 7.15182 21.7617C5.98181 21.7077 5.34681 21.5123 4.92355 21.348C4.36355 21.1305 3.96354 20.8705 3.54354 20.4505C3.12353 20.0305 2.86353 19.6315 2.64553 19.0713C2.48128 18.6488 2.28552 18.0138 2.23227 16.8438C2.17477 15.5788 2.16327 15.1988 2.16327 11.9943C2.16327 8.78975 2.17477 8.41175 2.23227 7.14675C2.28577 5.97675 2.48128 5.34175 2.64553 4.91875C2.86303 4.35875 3.12353 3.95875 3.54354 3.53875C3.96354 3.11875 4.36355 2.85875 4.92355 2.64075C5.34656 2.47575 5.98181 2.28075 7.15182 2.227C8.25884 2.177 8.68784 2.162 10.9244 2.1595V2.1625Z"
        fill="url(#paint0_radial_2144_3245)"
      />
      <path
        d="M18.3806 4.12552C18.0958 4.12552 17.8174 4.20999 17.5806 4.36824C17.3437 4.52649 17.1592 4.75142 17.0502 5.01457C16.9412 5.27773 16.9127 5.56729 16.9683 5.84664C17.0239 6.12598 17.1611 6.38257 17.3626 6.58393C17.564 6.7853 17.8206 6.92241 18.1 6.97791C18.3794 7.03342 18.6689 7.00483 18.9321 6.89577C19.1952 6.7867 19.42 6.60205 19.5782 6.36518C19.7364 6.12831 19.8208 5.84985 19.8207 5.56502C19.8207 4.77002 19.1756 4.12502 18.3806 4.12502V4.12552Z"
        fill="url(#paint1_radial_2144_3245)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9751 5.80802C8.57178 5.80802 5.81251 8.56727 5.81251 11.9705C5.81251 15.3738 8.57178 18.1318 11.9751 18.1318C15.3784 18.1318 18.1369 15.3738 18.1369 11.9705C18.1369 8.56727 15.3784 5.80802 11.9751 5.80802ZM12 15.9375C14.1746 15.9375 15.9375 14.1746 15.9375 12C15.9375 9.8254 14.1746 8.06252 12 8.06252C9.82538 8.06252 8.06251 9.8254 8.06251 12C8.06251 14.1746 9.82538 15.9375 12 15.9375Z"
        fill="url(#paint2_radial_2144_3245)"
      />
      <path
        d="M12.0009 0C8.74184 0 8.33284 0.0142502 7.05282 0.0725002C5.77531 0.131 4.9033 0.33325 4.14029 0.63C3.35104 0.9365 2.68153 1.3465 2.01452 2.01375C1.34701 2.68075 0.93701 3.35025 0.629506 4.13925C0.332003 4.9025 0.129501 5.77475 0.0720008 7.05175C0.0150002 8.33175 0 8.741 0 12C0 15.259 0.0145004 15.6668 0.072501 16.9468C0.131252 18.2243 0.333504 19.0963 0.630007 19.8593C0.93676 20.6485 1.34676 21.318 2.01402 21.985C2.68078 22.6525 3.35029 23.0635 4.13904 23.37C4.90255 23.6668 5.77481 23.869 7.05207 23.9275C8.33209 23.9858 8.74084 24 11.9996 24C15.2589 24 15.6667 23.9858 16.9467 23.9275C18.2242 23.869 19.0972 23.6668 19.8607 23.37C20.6497 23.0635 21.3182 22.6525 21.985 21.985C22.6525 21.318 23.0625 20.6485 23.37 19.8595C23.665 19.0963 23.8675 18.224 23.9275 16.947C23.985 15.667 24 15.259 24 12C24 8.741 23.985 8.332 23.9275 7.052C23.8675 5.7745 23.665 4.9025 23.37 4.1395C23.0625 3.35025 22.6525 2.68075 21.985 2.01375C21.3175 1.34625 20.65 0.93625 19.86 0.63C19.095 0.33325 18.2224 0.131 16.9449 0.0725002C15.6649 0.0142502 15.2574 0 11.9974 0H12.0009ZM10.9244 2.1625C11.2439 2.162 11.6004 2.1625 12.0009 2.1625C15.2049 2.1625 15.5847 2.174 16.8499 2.2315C18.0199 2.285 18.6549 2.4805 19.0779 2.64475C19.638 2.86225 20.0372 3.12225 20.457 3.54225C20.877 3.96225 21.137 4.36225 21.355 4.92225C21.5192 5.34475 21.715 5.97975 21.7682 7.14975C21.8257 8.41475 21.8382 8.79475 21.8382 11.9972C21.8382 15.1997 21.8257 15.5798 21.7682 16.8448C21.7147 18.0147 21.5192 18.6498 21.355 19.0723C21.1375 19.6323 20.877 20.031 20.457 20.4508C20.037 20.8708 19.6382 21.1308 19.0779 21.3482C18.6554 21.5133 18.0199 21.7082 16.8499 21.7617C15.5849 21.8192 15.2049 21.8318 12.0009 21.8318C8.79659 21.8318 8.41684 21.8192 7.15182 21.7617C5.98181 21.7077 5.34681 21.5123 4.92355 21.348C4.36355 21.1305 3.96354 20.8705 3.54354 20.4505C3.12353 20.0305 2.86353 19.6315 2.64553 19.0713C2.48128 18.6488 2.28552 18.0138 2.23227 16.8438C2.17477 15.5788 2.16327 15.1988 2.16327 11.9943C2.16327 8.78975 2.17477 8.41175 2.23227 7.14675C2.28577 5.97675 2.48128 5.34175 2.64553 4.91875C2.86303 4.35875 3.12353 3.95875 3.54354 3.53875C3.96354 3.11875 4.36355 2.85875 4.92355 2.64075C5.34656 2.47575 5.98181 2.28075 7.15182 2.227C8.25884 2.177 8.68784 2.162 10.9244 2.1595V2.1625Z"
        fill="url(#paint3_radial_2144_3245)"
      />
      <path
        d="M18.3806 4.12552C18.0958 4.12552 17.8174 4.20999 17.5806 4.36824C17.3437 4.52649 17.1592 4.75142 17.0502 5.01457C16.9412 5.27773 16.9127 5.56729 16.9683 5.84664C17.0239 6.12598 17.1611 6.38257 17.3626 6.58393C17.564 6.7853 17.8206 6.92241 18.1 6.97791C18.3794 7.03342 18.6689 7.00483 18.9321 6.89577C19.1952 6.7867 19.42 6.60205 19.5782 6.36518C19.7364 6.12831 19.8208 5.84985 19.8207 5.56502C19.8207 4.77002 19.1756 4.12502 18.3806 4.12502V4.12552Z"
        fill="url(#paint4_radial_2144_3245)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9751 5.80802C8.57178 5.80802 5.81251 8.56727 5.81251 11.9705C5.81251 15.3738 8.57178 18.1318 11.9751 18.1318C15.3784 18.1318 18.1369 15.3738 18.1369 11.9705C18.1369 8.56727 15.3784 5.80802 11.9751 5.80802ZM12 15.9375C14.1746 15.9375 15.9375 14.1746 15.9375 12C15.9375 9.8254 14.1746 8.06252 12 8.06252C9.82538 8.06252 8.06251 9.8254 8.06251 12C8.06251 14.1746 9.82538 15.9375 12 15.9375Z"
        fill="url(#paint5_radial_2144_3245)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.37503 25.8485) rotate(-90) scale(23.7858 22.1226)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.37503 25.8485) rotate(-90) scale(23.7858 22.1226)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.37503 25.8485) rotate(-90) scale(23.7858 22.1226)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.08689 10.4255 -42.9735 8.60689 -4.02013 1.72892)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.08689 10.4255 -42.9735 8.60689 -4.02013 1.72892)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2144_3245"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.08689 10.4255 -42.9735 8.60689 -4.02013 1.72892)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default Instagram;
